/**
 * ObjectsIcon — A cube in a viewfinder: an object in view. Hugeicons 3d-view (MIT).
 */

import svg from './svg/objects.svg?raw';
import { makeSvgIcon } from './svgIcon';

export const ObjectsIcon = makeSvgIcon('objects', svg);
